import React, { useState, useEffect } from 'react';
import MonoboxesTableDesktop from './MonoboxesTableDesktop';
import CreateMonobox from './CreateMonobox';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

const MonoboxesBlock = React.memo((props) => {
  const {
    product, // {} продукт, внутри которого массив вариантов
    variant, // {} текущий вариант вариативного продукта || false для не вариативного продукта
    setUnsavedStatus, // boolean отобразить/спрятать кнопку "Сохранить" в верхней панели
    monoboxesUpdateRef, // ref{} связывающий с родительским компонентом - для вызова запроса на апдейт по нажатию кнопки "Сохранить"
    refreshVariant, // func() обновляет state родителя - перерисовка страницы
  } = props;

  const [monoboxes, setMonoboxes] = useState([]);

  const { t } = useAutoTranslation();

  const updateMonoboxesState = (productVariants) => {
    let monoboxesForCurrentVariant = [];

    if (variant) {
      // Находим монокороба у текущего варианта в продукте с вариантами (SingleVariantPage)
      monoboxesForCurrentVariant = productVariants.filter(
        (pv) => pv?.parentPackageId === variant.id,
      );
    } else {
      // Находим монокороба у одиночного продукта без вариантов (SingleItemPage) - у них всех есть parentPackageId
      monoboxesForCurrentVariant = productVariants.filter((pv) => pv.parentPackageId);
    }

    //Если у варианта/продукта есть свои монокороба, трансформируем в словарь для редактирования отдельных полей в <TableRow />
    if (monoboxesForCurrentVariant.length >= 1) {
      setMonoboxes(monoboxesForCurrentVariant);
    } else {
      setMonoboxes([]);
    }
  };

  useEffect(() => {
    updateMonoboxesState(product.variants);
  }, [product]);

  const test = product.variants.filter((pv) => !pv.parentPackageId)[0];

  return (
    <div className="card-box">
      <div className="row">
        <div className="col-12">
          <div className="variant-list-header">
            <h4 className="header-title mb-0">{t('Монокороба')}</h4>
          </div>
          <CreateMonobox
            product={product}
            monoboxes={monoboxes}
            // Либо уже известный вариант в вариативном товаре,
            // либо единственый "вариант" не вариативного продукта, который единственный не содержит parentPackageId
            variant={variant ? variant : product.variants.filter((pv) => !pv.parentPackageId)[0]}
            updateMonoboxesState={updateMonoboxesState}
          />
          {monoboxes.length >= 1 ? (
            <MonoboxesTableDesktop
              product={product}
              currentMonoboxes={monoboxes}
              variant={variant ? variant : product.variants.filter((pv) => !pv.parentPackageId)[0]}
              setUnsavedStatus={setUnsavedStatus}
              monoboxesUpdateRef={monoboxesUpdateRef}
              refreshVariant={refreshVariant}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
});

export default MonoboxesBlock;
